import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useMembership } from '../../hooks/useMembership';

interface Props {
  role: 'director' | 'teacher';
  children: ReactNode;
}

/**
 * Allows access only if the user has the required role in at least one school.
 * If they have no membership at all, send them to onboarding.
 */
export function RequireRole({ role, children }: Props) {
  const { memberships, loading } = useMembership();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-ink-soft">
        <div className="animate-pulse">Chargement…</div>
      </div>
    );
  }

  if (memberships.length === 0) {
    return <Navigate to="/directeur/onboarding" replace />;
  }

  const has = memberships.some((m) =>
    role === 'teacher' ? true : m.role === 'director',
  );

  if (!has) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
